import { faChevronLeft, faPlay, faXmark } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from '@headlessui/react'
import { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'
import { placementData } from '../../utilities/constants'
import constants from '../../utilities/constants'
import { Mixpanel } from '../../config/Mixpanel'



const PlacementModal = ({ isOpen, setIsOpen }) => {

    const [ showPlayer, setShowPlayer ] = useState(false)
    const [ videoUrl, setVideoUrl ] = useState('')

    // Track modal open/close
    useEffect(() => {
        if (isOpen) {
            Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PLACEMENT_MODAL_OPENED, {
                timestamp: new Date().toISOString()
            })
        }
    }, [isOpen])

    const handleVideo = (index) => {
        const selectedVideo = placementData[index]
        
        setShowPlayer(true)
        setVideoUrl(selectedVideo?.video_link)

        // Track video selection
        Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PLACEMENT_VIDEO_CLICKED, {
            video_index: index,
            video_title: selectedVideo?.title || '',
            video_subtitle: selectedVideo?.subtitle || '',
            week_number: index + 1,
            video_url: selectedVideo?.video_link || '',
            timestamp: new Date().toISOString()
        })

        // Track video player opening
        Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PLACEMENT_VIDEO_PLAYER_OPENED, {
            video_index: index,
            video_title: selectedVideo?.title || '',
            week_number: index + 1,
            timestamp: new Date().toISOString()
        })
    }

    const closeModal = () => {
        setShowPlayer(false)
        setIsOpen(false)

        // Track modal close
        Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PLACEMENT_MODAL_CLOSED, {
            was_video_playing: showPlayer,
            current_video_url: videoUrl || '',
            timestamp: new Date().toISOString()
        })
    }

    const handleVideoPlayerBack = () => {
        setShowPlayer(false)

        // Track going back from video player
        Mixpanel.track(constants.Mixpanel.ONBOARDING_V2_PLACEMENT_VIDEO_PLAYER_BACK, {
            current_video_url: videoUrl || '',
            timestamp: new Date().toISOString()
        })
    }

    return (
        <div>
            <Dialog 
                open={isOpen}
                onClose={closeModal}
                as='div'
                className="absolute inset-0 flex flex-col mx-auto text-white"
                style={{ zIndex: '9999999999' }}
            >
                <Dialog.Overlay className="fixed inset-0 bg-black/60 z-10 my-auto backdrop-blur-[10px]" />
                <Dialog.Title/>
                <Dialog.Description/>
                {!showPlayer ? <div className='bg-[#2D4F71] max-w-2xl p-3 rounded-2xl relative max-h-[80dvh]  mx-auto my-auto z-[101] w-[90%] relative'>
                    <h3 className='text-xl leading-6 font-medium pr-8'>Standout & Become 100% Job Ready</h3>
                    <div className='absolute right-3 top-3 cursor-pointer' onClick={() => setIsOpen(false)}>
                        <FontAwesomeIcon icon={faXmark} className='text-2xl'/>
                    </div>
                    <p className='text-sm leading-4 text-white/50 mt-1'>Join our 4 week placement support & interview training program. Get hired 3x faster!</p>
                    <div className='flex flex-col gap-2 mt-5 relative'>
                        {placementData?.map((item, index) => (
                            <div key={index} className='flex items-center gap-2'>
                                {index === 0 ? <div className='flex flex-col items-center text-xs font-bold z-50'>
                                    <div className='w-[21px] h-[21px] border-[1.5px] text-[15px] font-bold bg-[#14395F] flex items-center justify-center rounded-full'>
                                        1
                                    </div>
                                    <p>&</p>
                                    <div className='w-[21px] h-[21px] border-[1.5px] text-[15px] font-bold bg-[#14395F] flex items-center justify-center rounded-full'>
                                        2
                                    </div>
                                </div> : <div className='z-50'>
                                    <div className='w-[21px] h-[21px] border-[1.5px] text-[15px] font-bold bg-[#14395F] flex items-center justify-center rounded-full'>
                                        {index + 2}
                                    </div>
                                </div>}
                                <div className='bg-[#14395F] flex-1 flex items-center gap-2 p-2 rounded-xl'>
                                    <div className='relative w-[85px] h-full cursor-pointer' onClick={() => handleVideo(index)}>
                                        <img src={item.thumbnail} className='w-full h-auto' alt="" />
                                        <FontAwesomeIcon icon={faPlay} className='absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2'/>
                                    </div>
                                    <div className='flex-1'>
                                        <h3 className='text-sm font-semibold text-white/50'>Week {index + 1}</h3>
                                        <p className='text-[11px] font-semibold'>{item.title}</p>
                                        <p className='text-[11px] font-semibold text-white/70 leading-3'>{item.subtitle}</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className='w-2 absolute h-[73%] bg-[#6582A0] top-[18%] left-[7px]'/>
                    </div>
                </div> : <div className='bg-[#2D4F71] max-w-2xl p-3 rounded-2xl mx-auto my-auto z-[101] w-[90%] relative'>
                    <div className='flex justify-between items-center mb-3 px-2'>
                        <FontAwesomeIcon icon={faChevronLeft} className='text-2xl cursor-pointer' onClick={handleVideoPlayerBack}/>
                        <FontAwesomeIcon icon={faXmark} className='text-3xl cursor-pointer' onClick={closeModal}/>
                    </div>
                    <ReactPlayer
                        url={videoUrl}
                        config={{
                        file: {
                            attributes: {
                            preload: 'auto',
                            },
                        },
                        youtube: {
                            playerVars: { modestbranding: 1, rel: 0 },
                        },
                        }}
                        width={"100%"}
                        height={
                        window.innerWidth > 768
                            ? window.innerWidth * (9 / 16) * (5 / 12)
                            : window.innerWidth * (9 / 16)
                        }
                        controls={true}
                        playing={true}
                    />
                </div>}
            </Dialog>
        </div>
    )
}

export default PlacementModal